import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
      <div className="text-center max-w-lg">
        <span className="font-heading font-bold text-primary-200 text-6xl md:text-8xl block mb-4">
          404
        </span>
        <h1 className="font-heading font-bold text-foreground-900 text-2xl md:text-3xl mb-3">
          Seite nicht gefunden
        </h1>
        <p className="text-foreground-600 mb-6 md:mb-8 text-sm md:text-base">
          Die von Ihnen gesuchte Seite existiert nicht oder wurde verschoben. Bitte überprüfen Sie die URL oder kehren Sie zur Startseite zurück.
        </p>
        <Link
          to="/"
          className="inline-flex items-center justify-center px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap text-sm md:text-base"
        >
          Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
}